import { usePageTitle } from '@app/hooks/usePageTitle';
import RoutingConfigViewWidget from '@widgets/routing/config-view';

const RoutingConfigPage = () => {
  usePageTitle('Routing Config');

  return <RoutingConfigViewWidget />;
};

export default RoutingConfigPage;
